import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "@/pages/auth/AuthShell";
import { api, apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [note, setNote] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.get("/auth/email-status").then((r) => { if (!r.data.configured) setNote("Nota: l'invio email potrebbe non essere ancora attivo in questo ambiente."); });
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) { setSent(true); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Recupera password" subtitle="Ti invieremo un link per reimpostare la password."
      footer={<Link to="/accedi" className="text-[#2DD4BF] hover:underline">Torna all'accesso</Link>}>
      {sent ? (
        <div className="text-center" data-testid="forgot-sent">
          <MailCheck className="mx-auto h-12 w-12 text-[#10B981]" />
          <p className="mt-4 text-[#CBD5E1]">Se esiste un account associato a questa email, riceverai un link per reimpostare la password.</p>
          {note && <p className="mt-3 text-xs text-[#F59E0B]">{note}</p>}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label htmlFor="email" className="text-[#CBD5E1]">Email</Label>
            <Input id="email" data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#0B1020] border-[#2A3655]" />
          </div>
          <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full bg-[#7C3AED] hover:bg-[#6D28D9]">{loading ? "Invio…" : "Invia link di recupero"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
